import { createContext, useRef, useState } from 'react';

const ALERT_TIME = 2000;
const initialState = {
  text: '',
  type: '',
};

const AlertContext = createContext({
  ...initialState,
  setAlert: () => {},
  clearAlert: () => {},
});

export const AlertContextProvider = ({ children }) => {
  const [text, setText] = useState('');
  const [type, setType] = useState('');
  const timer = useRef();

  const clearAlert = () => {
    clearTimeout(timer.current);
    setText('');
    setType('');
  };

  const setAlert = (text, type) => {
    clearTimeout(timer.current);
    setText(text);
    setType(type);

    timer.current = setTimeout(() => {
      setText('');
      setType('');
    }, ALERT_TIME);
  };

  return (
    <AlertContext.Provider
      value={{
        text,
        type,
        setAlert,
        clearAlert,
      }}
    >
      {children}
    </AlertContext.Provider>
  );
};

export default AlertContext;
